// pdfhtmlServicee.ts

import api from "@/services/api";

export interface PdfPageRequest {
  fileName: string;
  pageNumber: number;
}
export interface PdfPagesRequest {
  quizName: string;
  paper: string;
  pageNumbers: number[];
}

export interface PdfPageResponse {
  html: string;
  pageNumber: number;
  fileName: string;
}

/**
 * PDF HTML Page Viewer Service
 */
const pdfViewerApi = {
  /**
   * Get a specific page as HTML (from pre-split pages)
   */
  getPage: async ({ fileName, pageNumber }: PdfPageRequest): Promise<string> => {
    const response = await api.get<string>(`/pdf/page`, {
      params: {
        fileName,
        pageNumber,
      },
      // Important: We expect raw HTML text, not JSON
      responseType: "text",
    });

    return response.data;
  },

  /**
   * Optional: Get multiple pages at once (for future use)
   */
  getPages: async ({ quizName, paper, pageNumbers }: PdfPagesRequest): Promise<string> => {
    const response = await api.get<string>(`/pdf/pages`, {
      params: {
        quizName,
        paper,
        pageNumbers,
      },
      // Important: We expect raw HTML text, not JSON
      responseType: "text",
    });

    return response.data;
  },
};

export default pdfViewerApi;
